import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      component: () => import("./views/Main.vue"),
      children: [
        { path: "", redirect: "/principal" },
        { path: "principal", name: "principal", component: () => import("./views/Principal/index.vue") },
        { path: "product", name: "product", component: () => import("./views/Principal/product.vue") },
      ],
    },
    { path: "/login", name: "login", component: () => import("./views/Login/Login.vue") },
    { path: "/register", name: "register", component: () => import("./views/Login/Register.vue") },
    { path: "/config", name: "config", component: () => import("./views/Confing/Main.vue") },
    { path: "*", redirect: "/principal" },
  ],
});
